import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { getSlaReport } from '../services/api';
import { fmtDateDMY } from '../utils/format';
import { Pill, STATUS_COLORS, Th } from './NotionUI';

/** Scadenze e rispetto dei tempi: in ritardo, in scadenza nelle prossime 48 ore, % chiusi entro la scadenza (ultimi 30 giorni). */
function SlaPanel() {
  const { t } = useLanguage();
  const [sla, setSla] = useState(null);

  useEffect(() => {
    getSlaReport().then(setSla).catch(() => setSla(null));
  }, []);

  if (!sla || (sla.totals.open === 0 && sla.totals.resolved_30d === 0)) return null;
  const tot = sla.totals;

  return (
    <section className="db-card sla-card">
      <header className="db-card-head"><h3>{t('dashboard.slaTitle')}</h3></header>
      <div className="sla-stats">
        <div className={'sla-stat' + (tot.overdue > 0 ? ' sla-stat-bad' : '')}><strong>{tot.overdue}</strong><span>{t('dashboard.slaOverdue')}</span></div>
        <div className={'sla-stat' + (tot.due_soon > 0 ? ' sla-stat-warn' : '')}><strong>{tot.due_soon}</strong><span>{t('dashboard.slaDueSoon')}</span></div>
        <div className="sla-stat"><strong>{tot.no_due_date}</strong><span>{t('dashboard.slaNoDue')}</span></div>
        <div className="sla-stat"><strong>{tot.within_due_pct === null ? '—' : `${tot.within_due_pct}%`}</strong><span>{t('dashboard.slaWithin', { count: tot.with_due })}</span></div>
      </div>
      {sla.first_response && (sla.first_response.pending_overdue > 0 || sla.first_response.met + sla.first_response.missed > 0) && (
        <div className="sla-stats">
          <div className={'sla-stat' + (sla.first_response.pending_overdue > 0 ? ' sla-stat-bad' : '')}><strong>{sla.first_response.pending_overdue}</strong><span>{t('dashboard.slaFirstLate')}</span></div>
          <div className="sla-stat"><strong>{sla.first_response.met_pct === null ? '—' : `${sla.first_response.met_pct}%`}</strong><span>{t('dashboard.slaFirstMet', { count: sla.first_response.met + sla.first_response.missed })}</span></div>
        </div>
      )}

      <div className="nt-table-wrap">
        <table className="nt-table cu-table">
          <thead>
            <tr>
              <Th icon="tag">{t('dashboard.slaQueue')}</Th>
              <Th icon="hash">{t('dashboard.slaOpen')}</Th>
              <Th icon="hash">{t('dashboard.slaOverdue')}</Th>
              <Th icon="hash">{t('dashboard.slaDueSoon')}</Th>
              <Th icon="hash">{t('dashboard.slaResolved30')}</Th>
              <Th icon="hash">{t('dashboard.slaWithinShort')}</Th>
              <Th icon="clock">{t('dashboard.slaAvg')}</Th>
              <Th icon="calendar">{t('dashboard.slaTarget')}</Th>
            </tr>
          </thead>
          <tbody>
            {sla.by_queue.map((q) => (
              <tr key={q.queue}>
                <td><strong>{q.queue}</strong></td>
                <td>{q.open}</td>
                <td className={q.overdue > 0 ? 'sla-bad' : ''}>{q.overdue}</td>
                <td className={q.due_soon > 0 ? 'sla-warn' : ''}>{q.due_soon}</td>
                <td>{q.resolved_30d}</td>
                <td>{q.within_due_pct === null ? '—' : `${q.within_due_pct}%`}</td>
                <td>{q.avg_resolution_hours === null ? '—' : q.avg_resolution_hours}</td>
                <td>{q.target_days ? t('dashboard.slaDays', { count: q.target_days }) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {sla.by_person.length > 0 && (
        <p className="sla-people">
          <strong>{t('dashboard.slaPeople')}</strong>{' '}
          {sla.by_person.map((p) => `${p.person} (${[p.overdue > 0 ? t('dashboard.slaNOverdue', { count: p.overdue }) : null, p.due_soon > 0 ? t('dashboard.slaNSoon', { count: p.due_soon }) : null].filter(Boolean).join(', ')})`).join(' · ')}
        </p>
      )}

      {sla.attention.length > 0 && (
        <ul className="rp-list sla-list">
          {sla.attention.map((tk) => (
            <li key={tk.id} className="rp-li">
              <Link to={`/tickets/${tk.id}`} state={{ from: '/dashboard' }} className="rp-link">
                <span className="rp-id">#{tk.id}</span>
                <span className="rp-subject">{tk.subject}</span>
              </Link>
              <Pill dot color={STATUS_COLORS[tk.status]}>{t(`tickets.status_${tk.status}`)}</Pill>
              <span className={'rp-extra ' + (tk.sla === 'overdue' || tk.sla === 'first_response' ? 'sla-bad' : 'sla-warn')}>
                {tk.sla === 'first_response' ? t('dashboard.slaFirstWasDue', { date: fmtDateDMY(tk.sla_due) }) : tk.sla === 'overdue' ? t('dashboard.slaWasDue', { date: fmtDateDMY(tk.due_at) }) : t('dashboard.slaDueOn', { date: fmtDateDMY(tk.due_at) })}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default SlaPanel;
